import { getCountry, getBrowserPlatform } from "@/utils/common.js";
const app = {
  namespaced: true,
  state: {
    transitionName: "slide-left",
    lang: "", // "zh-CN", "en-US"
    country: getCountry(), // china | my
    currencyUnit: "", // 元
    currencySymbol: "", // ￥
    userAuthToken: localStorage.getItem("authtoken") || "",
    browserPlatform: getBrowserPlatform()
  },
  getters: {},
  mutations: {
    setTransitionName(state, name) {
      state.transitionName = name;
    },
    setLang(state, lang) {
      state.lang = lang;
    },
    setCurrencyUnit(state, data) {
      state.currencyUnit = data;
    },
    setCurrencySymbol(state, data) {
      state.currencySymbol = data;
    }
  },
  actions: {}
};

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js